var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bs",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-12 0h640v480H-12z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M968.5 480h-979V1.8h979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe900",
    d: "M968.5 344.5h-979V143.3h979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08ced6",
    d: "M968.5 480h-979V320.6h979zm0-318.7h-979V2h979z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11 0c2.3 0 391.8 236.8 391.8 236.8L-12 479.2-10.9 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/bs.1663df4613f132b9b0aff0967f8e37cc.svg";
export { ForwardRef as ReactComponent };